import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { Pagination, Paper } from '@dev/ee-components';

import { JourneyStatus } from '@dev/ee-api/ee-api-models/journey-status';
import { GetAllAutomationsStart, getAutomationStore, UnpickAllAutomations } from '@/store/automations/actions';
import useMobile from '@/services/hooks/useMobile';
import AutomationsDraftsTable from './components/AutomationsDraftsTable';
import MobileDraftsTable from './components/MobileDraftTable';
import MobileFiltersComponent from './components/MobileFilters';
import { useRequestParams } from '../hooks/useRequestParams';

const CustomPagination: FC = (): JSX.Element => {
    const automations = useSelector(getAutomationStore);
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const defaultStatuses = [JourneyStatus.Inactive];
    const params = useRequestParams(defaultStatuses);

    const totalCount = automations?.loading ? 0 : automations?.statusCounts?.total;

    const changePage = (page: number, perPage: number): void => {
        const offset = page * perPage - perPage;
        dispatch(GetAllAutomationsStart({ ...params, limit: perPage, offset }));
    };

    const activePage = (params.offset + params.limit) / params.limit;

    return isEmpty(automations?.collection) && !automations?.loading ? null : isMobile ? (
        <Paper padding={{ top: 24, bottom: 24 }}>
            <Pagination
                dataLength={totalCount}
                perPage={params.limit}
                activePage={activePage}
                handlePaginationChange={changePage}
                disableBorderTop={true}
            />
        </Paper>
    ) : (
        <Pagination
            dataLength={totalCount}
            perPage={params.limit}
            activePage={activePage}
            handlePaginationChange={changePage}
        />
    );
};

const AutomationDraftsList: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const defaultStatuses = [JourneyStatus.Inactive];
    const requestParams = useRequestParams(defaultStatuses);

    useEffect(() => {
        dispatch(GetAllAutomationsStart(requestParams));
        return () => {
            dispatch(UnpickAllAutomations());
        };
    }, []);

    if (isMobile) {
        return (
            <>
                <MobileFiltersComponent />
                <MobileDraftsTable />
                <CustomPagination />
            </>
        );
    }

    return (
        <Paper margin={{ top: 32 }}>
            <AutomationsDraftsTable />
            <CustomPagination />
        </Paper>
    );
};

export default AutomationDraftsList;
